import {KEYS} from "../../../../l18n/constants";
import { useL18nContext } from '../../ContextProvider/L18n';
import computeClassName from '../../../../utils/computeClassName';
import CCBadgeLight from "../../../libs/CiscoCore/Badge/Light";

const constants = Object.freeze({
  CLASSNAME_BASE: 'px-4 sm:px-6'
});
const propsDefaults = Object.freeze({
  isDiversePartner: false
});

export default function DiversePartnerIndicator(
  {
    isDiversePartner = propsDefaults.isDiversePartner,
    className = ''
  }
) {
  const { getTranslationFor } = useL18nContext();
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  if (isDiversePartner) {
    return (
      <div className={computedClassName}>
        <CCBadgeLight size="small">{getTranslationFor(KEYS.L18N_KEY_LABEL_DIVERSE_PARTNER)}</CCBadgeLight>
      </div>
    );
  }
  else {
    return (
      <div className={computedClassName}>&nbsp;</div>
    );
  }
}
